import {
    CALL_INIT_STATE,
    SET_ACCOUNT_MANAGERS,
    SET_CONFIRMATION_CALL_LIST,
    SET_CONFIRMATION_CALL_LIST_META, SET_CONFIRMATION_CALL_STATISTICS,
    SET_BRANCHES,
    SET_NOT_COMPLETED_CONFIRMATION_CALLS
} from "./types";

export const callReducer = (state = CALL_INIT_STATE, action) => {
    switch (action.type) {
        case SET_CONFIRMATION_CALL_LIST:
            return {...state, confirmationCallList: action.payload};
        case SET_CONFIRMATION_CALL_LIST_META:
            return {...state, confirmationCallListMeta: action.payload};
        case SET_ACCOUNT_MANAGERS:
            return {...state, accountManagers: action.payload};
        case SET_CONFIRMATION_CALL_STATISTICS:
            return {...state, confirmationCallStatistics: action.payload};
        case SET_BRANCHES:
            return {...state, branches: action.payload};
        case SET_NOT_COMPLETED_CONFIRMATION_CALLS:
            return {...state, notCompletedConfirmationCalls: action.payload};
        default:
            return state
    }
}